// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLumeraCaution_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.4389 13.8246C17.691 13.3918 18.309 13.3918 18.5611 13.8246L23.9086 23.0044C24.1649 23.4445 23.8518 24 23.3475 24H12.6525C12.1482 24 11.8351 23.4445 12.0914 23.0044L17.4389 13.8246Z" fill="#FDCA40"/>
  <path d="M18.9792 15.3809 17.021 16.0194V20.2764H18.9792V15.3809ZM18.9792 21.2554H17.021V23.2137H18.9792V21.2554Z" fill="#1A2329"/>
  <path d="M9.10305 1H0V9H4.21252C4.39573 8.29586 4.61137 7.62963 4.85599 7H2L2 3H7.13491C7.59471 2.42575 8.08685 1.90408 8.60453 1.43241 8.76916 1.28242 8.93544 1.13834 9.10305 1ZM5 18.9511V24H7V20L11 17.2353V13L0 16V24H2V17.5276L9 15.6185V16.1864L5 18.9511Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19 0H17V4H15V8.8309L12 9.63121L12.5176 11.5631L15 10.9014V12H21V10.901L23.4472 11.5602L24 9.62839L21 8.83043V4H19V0ZM19 6H17V10H19V6Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.95151 2.9108C12.4092 0.671588 15.2846 0 17 0V2C15.7154 2 13.3408 2.52841 11.2985 4.3892C9.28965 6.21947 7.5 9.43311 7.5 15H5.5C5.5 8.96689 7.46035 5.18053 9.95151 2.9108Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLumeraCaution is a generated icon component.
 */
let IconMedLumeraCaution = IconMedLumeraCaution_1 = class IconMedLumeraCaution extends IconBaseElement {
    render() {
        return html `${IconMedLumeraCaution_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLumeraCaution.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLumeraCaution = IconMedLumeraCaution_1 = __decorate([
    customElement('zui-icon-med-lumera-caution')
], IconMedLumeraCaution);
export { IconMedLumeraCaution };
